import CategorizedTagInput from './CategorizedTagInput.jsx';
export default CategorizedTagInput;



// WEBPACK FOOTER //
// ./src/index.js